export default "__VITE_ASSET__5bf4c0a2__"